import { cn } from '@workspace/ui/lib/utils';
import { useProfileUIStore } from '../store/profile-ui-store';
import { IBit, IProfile, IProject, ITile } from 'types/src/types';

import { Navigation } from './Navigation';

type Props = {
  profile: IProfile;
  isMyProfile: boolean;
  initialTiles: ITile[] | null;
  unpublishedProjects?: IProject[];
};

export const ProfileGrid = ({
  profile,
  isMyProfile,
  initialTiles,
  unpublishedProjects,
}: Props) => {
  const isMobileView = useProfileUIStore((state) => state.isMobileView);

  return (
    <div
      className={cn('col-span-2', {
        'md:col-span-6 lg:col-span-8': !isMobileView,
      })}
    >
      <Navigation
        profile={profile}
        isMyProfile={isMyProfile}
        initialTiles={initialTiles}
        unpublishedProjects={unpublishedProjects}
      />
    </div>
  );
};
